<template>
  <div>
    <div class="tab-box">
      <div class="tab-box-innder">
        <div
          v-for="(item, index) in data"
          :key="index"
          class="tab-box-item"
          :class="{ active: item.value == targeIndex }"
          :data-value="item.value"
          @click="tabClick(index, item, true)"
        >
          {{ item.label }}
        </div>
      </div>
      <div ref="slider" class="tab-box-slider"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TabNoneResponse",
  props: ["data", "defaultValue"],
  data() {
    return {
      targeIndex: 3, // 007 - 1 | z03 - 2 | A06 - 3
      screenWidth: null, //屏幕尺寸
    };
  },
  computed: {},
  watch: {
    screenWidth: {
      handler: function() {
        this.doAni(this.targeIndex, true);
      },
      immediate: true,
    },
    data() {
      this.$nextTick(() => {
        this.doAni(this.targeIndex, true);
      });
    },
    defaultValue: {
      handler: function(val) {
        this.targeIndex = val || this.data[0].value;
      },
      immediate: true,
    },
  },
  created() {},
  mounted() {
    this.doAni(this.targeIndex, true);
    this.screenWidth = document.body.clientWidth;
    window.onresize = () => {
      //屏幕尺寸变化就重新赋值
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };
  },
  methods: {
    doAni(value, noAni) {
      let el = Array.from(document.querySelectorAll(".tab-box-item")).find(
        (item) => {
          return Number(item.getAttribute("data-value")) === Number(value);
        }
      );
      if (!el) return;
      let left = el.offsetLeft;
      let { slider } = this.$refs;
      let aniText =
        "transition: transform 260ms cubic-bezier(0.33, 1, 0.68, 1);";
      if (noAni) {
        aniText = "";
      }
      slider.style.cssText = `transform:translateX(${left}px);${aniText}`;
    },
    tabClick(index, item, ani, close) {
      this.targeIndex = item.value;
      this.$emit("change", index, item);
      ani && this.doAni(item.value);
      close && this.open();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@style/base";

.tab-box {
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  @include setThemeClass {
    .tab-box-slider {
      position: absolute;
      z-index: 1;
      left: 0px;
      top: -1px;
      bottom: -1px;
      background-color: getThemeVal(brandColorBlack);
      width: calc(100% / 4);
      // width: 111px;
      // @include media(
      //   (
      //     $bg: (
      //       width: 71px,
      //     ),
      //     $md: (
      //       width: 111px,
      //     ),
      //     $sm: (
      //       width: 61px,
      //     ),
      //   )
      // );
    }
    .tab-box-innder {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      border: 1px solid #131415;
      width: 100%;
      .tab-box-item {
        position: relative;
        box-sizing: border-box;
        height: 36px;
        line-height: 36px;
        text-align: center;
        cursor: pointer;
        z-index: 2;
        font-size: 14px;
        &.active {
          color: getThemeVal(brandColorWhite);
        }
        // width: 110px;
        width: calc(100% / 4);
        // @include media(
        //   (
        //     $bg: (
        //       width: 70px,
        //     ),
        //     $md: (
        //       width: 110px,
        //     ),
        //     $sm: (
        //       width: 60px,
        //     ),
        //   )
        // );
      }
    }
  }
}
</style>
